/**
 * Reads a File's content as text.
 *
 * Prefer this over `File.prototype.text()`: it isn't implemented in the jsdom version this
 * project's Jest tests run against, so code relying on it can't be tested here even though it
 * works in every real browser.
 */
export function readFileAsText(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsText(file);
  });
}

/**
 * Formats a number of bytes into a human-readable string with units.
 * @param bytes The number of bytes.
 * @returns A formatted string representing the size in appropriate units.
 */
export function formatBytes(bytes: number) {
  if (!bytes) return "";
  const k = 1024;
  const sizes = ["B", "KB", "MB", "GB"];
  const idx = Math.floor(Math.log(bytes) / Math.log(k));
  return `${(bytes / Math.pow(k, idx)).toFixed(1)} ${sizes[idx]}`;
}
